export enum MembershipStatus {
	Pending,
	Active,
	Expired,
	Cancelled,
	Interested,
	Archived
}

export enum TimePeriod {
	Days,
	Weeks,
	Months,
	Years
}
